import { Box, Button, Card, Modal, Typography } from "@mui/material";
import { icons } from "../../assets/icons/icons";
import { colors } from "../../values/colors";

const ResetModal = ({ open, onClose, onResetCurrent, onReset }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          width: 400,
          px: 3,
          py: 6,
          borderRadius: "16px",
          boxShadow: "0px 4px 25px rgba(0,0,0,0.15)",
          textAlign: "center",
        }}
      >
        <img src={icons.warn} alt="warn" />
        <Typography sx={{ fontSize: "1.2rem", fontWeight: "600", my: "3rem" }}>
          Select Appropriate Action
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "1.5rem",
          }}
        >
          <Button
            variant="contained"
            onClick={onResetCurrent}
            sx={{
              background: colors.linearGradent,
              color: "#fff",
              textTransform: "none",
              borderRadius: "999px",
              py: ".9rem",
              fontSize: "1rem",
              //   width: "120px",
            }}
          >
            Reset Current Stage
          </Button>
          <Button
            variant="contained"
            onClick={onReset}
            sx={{
              background: colors.linearGradent,
              color: "#fff",
              textTransform: "none",
              py: ".9rem",
              borderRadius: "999px",
              fontSize: "1rem",
              //   width: "120px",
            }}
          >
            Reset Auction
          </Button>
        </Box>
      </Card>
    </Modal>
  );
};

export default ResetModal;
